import ClientSidebar from "../../../../components/Generic/ClientSidebar";
import React from "react";
import ClientOverview from "../ClientOverview/ClientOverview";
import ClientLifeCycle from "../ClientLifeCycle/ClientLifeCycle";
import ClientReport from "../ClientReport/ClientReport";
import Funding from "../Revenue/Funding/Funding";
import AumAccordianTable from "../Revenue/AUM/Aum";
import PlatformsSegmentsBlock from "@frameworks/salesjourney/components/Features/ClientDetails/ClientOverview/PlatformsSegments/PlatformsSegmentsBlock";
import PastInteraction from "@frameworks/salesjourney/components/Features/ClientDetails/ClientOverview/PastInteractions/PastInteraction";
// import EligibilityBlock from "@frameworks/salesjourney/components/Features/ClientDetails/ClientOverview/Eligibility/EligibilityBlock";
import ClientOwners from "@frameworks/salesjourney/components/Features/ClientDetails/ClientOverview/ClientOwners/ClientOwners";
import DpDetailsMainBlock from "@frameworks/salesjourney/components/Features/ClientDetails/ClientOverview/DpDetails/DpDetailsMainBlock";
import ServiceRequest from "../ServiceRequest/ServiceRequest";
import BrokingOverview from "../Revenue/Broking/BrokingOverview";
import CustomerServicing from "../ClientOverview/CustomerServicing";
import ApplyFORNCD from "../ClientOverview/ApplyFORNCD";
import { roundOffWithZeros } from "@domains/utils/numberMethods";
import OutboundRedirection from "./OutboundRedirection";
import { ILoginTypeEnum, } from "@domains/salesFeatures/Login/entities/iLogin";
import PartnerProfile from "../PartnerOverview/PartnerProfileDetails";
import PartnerDemoGraphics from "../PartnerOverview/PartnerDemoGraphics";
import PartnerBank from "../PartnerOverview/PartnerBank";
import PartnerMapping from "../PartnerOverview/PartnerMapping";
import PartnerNominee from "../PartnerOverview/PartnerNominee";
import PartnerSegment from "../PartnerOverview/PartnerSegment";
import PartnerRegistrationDetails from "../PartnerOverview/PartnerRegistration";
import PartnerCertificationDetails from "../PartnerOverview/PartnerCertificationDetails";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import ClientFamilies from "../ClientOverview/ClientFamilies/ClientFamilies";
export var padZeros = function (padstring, length, isNegative, doRoundOff) {
    var _a;
    var resultString = "";
    if (padstring !== undefined && padstring !== null) {
        if (doRoundOff) {
            padstring = roundOffWithZeros(padstring);
        }
        if (isNegative && padstring.toString().includes("-")) {
            padstring = Number(padstring.toString().replace("-", ""));
        }
        if (padstring.toString() !== "" && padstring.toString().includes(".")) {
            if (((_a = padstring.toString().split(".")) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                resultString =
                    padstring.toString().split(".")[0].padStart(length, "0") +
                        "." +
                        padstring.toString().split(".")[1].padEnd(length, "0");
                if (isNegative) {
                    resultString = "-" + resultString;
                }
            }
        }
        else {
            resultString = padstring.toString().padStart(length, "0");
        }
    }
    return resultString;
};
export var partnerOverview = [
    {
        title: "Profile",
        eventKey: "profile",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerProfile, null))),
    },
    {
        title: "Demographics",
        eventKey: "demoGraphics",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerDemoGraphics, null))),
    },
    {
        title: "Bank",
        eventKey: "bank",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerBank, null))),
    },
    {
        title: "Registration Details",
        eventKey: "regDetails",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerRegistrationDetails, null))),
    },
    {
        title: "Certification",
        eventKey: "certification",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerCertificationDetails, null))),
    },
    {
        title: "Mapping",
        eventKey: "mapping",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerMapping, null))),
    },
    {
        title: "Nominee",
        eventKey: "nominee",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerNominee, null))),
    },
    {
        title: "Segment",
        eventKey: "segment",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement(PartnerSegment, null))),
    },
];
export var overview = [
    {
        title: "Overview",
        eventKey: "overview",
        tabContent: React.createElement(ClientOverview, null),
        subList: [
            { subTitle: "Personal Details", scrollId: "personal-details" },
            { subTitle: "Profile Details", scrollId: "profile-details" },
            { subTitle: "Account Details", scrollId: "account-details" },
            // { subTitle: "Nominee Details", scrollId: "nominee-details" },
            // { subTitle: "FATCA Details", scrollId: "fatca-details" },
        ],
    },
    {
        title: "Client Families",
        eventKey: "client_families",
        tabContent: React.createElement(ClientFamilies, null),
    },
    {
        title: "Client Owners",
        eventKey: "owners",
        tabContent: React.createElement(ClientOwners, null),
        subList: [
            { subTitle: "Client Owners", scrollId: "client-owners" },
            { subTitle: "Elliance Program", scrollId: "elliance-program" },
            { subTitle: "Relationship History", scrollId: "relationship-history" },
        ],
    },
    {
        title: "DP/Bank/UPI",
        eventKey: "bank",
        tabContent: React.createElement(DpDetailsMainBlock, null),
    },
    {
        title: "Platform & Segments",
        eventKey: "platform",
        tabContent: React.createElement(PlatformsSegmentsBlock, null),
    },
    // {
    //     title: "Eligibility",
    //     eventKey: "eligibility",
    //     tabContent: <EligibilityBlock />,
    // },
    {
        title: "Outbound",
        eventKey: "outbound",
        tabContent: React.createElement(OutboundRedirection, null),
    },
    {
        title: "Past Interactions",
        eventKey: "past",
        tabContent: React.createElement(PastInteraction, null),
    },
    {
        title: "Customer Servicing",
        eventKey: "customer",
        tabContent: React.createElement(CustomerServicing, null),
    },
    {
        title: "Apply for NCD",
        eventKey: "ncd",
        tabContent: React.createElement(ApplyFORNCD, null),
    },
];
export var revenue = [
    {
        title: "Broking",
        eventKey: "broking",
        tabContent: React.createElement(BrokingOverview, null),
        subList: [
            { subTitle: "Account Details", scrollId: "profile-details" },
            { subTitle: "Brokerage & Volume", scrollId: "brokerage-vol" },
            { subTitle: "Brokerage Plan", scrollId: "brokerage-plan" },
            { subTitle: "Pay-in Details", scrollId: "pay-in-details" },
        ],
    },
    {
        title: "AUM",
        eventKey: "aum",
        tabContent: React.createElement(AumAccordianTable, null),
    },
    {
        title: "Funding",
        eventKey: "funding",
        tabContent: React.createElement(Funding, null),
    },
    // {
    //     title: "Mortgage",
    //     eventKey: "mortgage",
    //     tabContent: <Mortgage />,
    // },
    // {
    //     title: "Insurance",
    //     eventKey: "insurance",
    //     tabContent: <GeneralInsurance />,
    // },
    // {
    //     title: "Offer",
    //     eventKey: "offers",
    //     tabContent: <Offers />,
    // },
];
export var EClientTabs;
(function (EClientTabs) {
    EClientTabs["OVERVIEW"] = "overview";
    EClientTabs["REVENUE"] = "revenue";
    EClientTabs["LIFECYCLE"] = "lifecycle";
    EClientTabs["SERVICEREQUEST"] = "servicerequest";
    EClientTabs["REPORT"] = "reports";
    EClientTabs["PARTNEROVERVIEW"] = "partneroverview";
})(EClientTabs || (EClientTabs = {}));
// const getTabsList = () => {
//   let tabsList =;
//   if (loginData.loginType === ILoginTypeEnum.PARTNER_LOGIN) {
//     tabsList = [
//       {
//         title: "Partner Overview",
//         eventKey: EClientTabs.PARTNEROVERVIEW,
//         tabContent: (
//           <ClientSidebar
//             links={partnerOverview}
//             externalClassName="overview-sidebar"
//           />
//         ),
//       },
//     ];
//   }
//   return tabsList;
// };
export var clientTabs = [
    {
        title: "Client Overview",
        eventKey: EClientTabs.OVERVIEW,
        tabContent: (React.createElement(ClientSidebar, { links: overview, externalClassName: "overview-sidebar" })),
    },
    {
        title: "Revenue",
        eventKey: EClientTabs.REVENUE,
        tabContent: React.createElement(ClientSidebar, { links: revenue }),
    },
    {
        title: "Client Life Cycle",
        eventKey: EClientTabs.LIFECYCLE,
        tabContent: React.createElement(ClientLifeCycle, null),
    },
    {
        title: "Service Request",
        eventKey: EClientTabs.SERVICEREQUEST,
        tabContent: React.createElement(ServiceRequest, null),
    },
    {
        title: "Report",
        eventKey: EClientTabs.REPORT,
        tabContent: React.createElement(ClientReport, null),
    },
];
export var partnerTabs = [
    {
        title: "Partner Overview",
        eventKey: EClientTabs.PARTNEROVERVIEW,
        tabContent: (React.createElement(ClientSidebar, { links: partnerOverview, externalClassName: "overview-sidebar" })),
    },
];
export var getIsPartner = function (loginData) {
    // let isPartner: boolean = false;
    var loginType = localStorage.getItem(ELocalStorageKeys.LoginType);
    // if (
    //   loginData &&
    //   !!loginData?.loginType &&
    //   loginData?.loginType === ILoginTypeEnum.FRM
    // ) {
    //   isPartner = true;
    // } else if (
    //   localStorage.getItem(ELocalStorageKeys.LoginType) !== null &&
    //   localStorage.getItem(ELocalStorageKeys.LoginType) !== undefined &&
    //   localStorage.getItem(ELocalStorageKeys.LoginType) !== "" &&
    //   localStorage.getItem(ELocalStorageKeys.LoginType) === ILoginTypeEnum.FRM
    // ) {
    //   isPartner = true;
    // }
    // return isPartner;
    return ((loginData === null || loginData === void 0 ? void 0 : loginData.loginType) === ILoginTypeEnum.FRM ||
        loginType === ILoginTypeEnum.FRM);
};
